module.exports = __webpack_public_path__ + "img/human_child_20180531.b61f54e3.png";